export default __webpack_public_path__ + "static/media/basic-pin-small-2.02ae7f5d.png";